import AppConstants from "../config/app.constants";

let ServiceTicketPartsService = ($http) => {

    let all = (search, offset, limit) => {
        return $http
            .get(AppConstants.api + `/service-ticket-parts`, {
                params: { search, offset, limit }
            })
            .then((res) => {
                return res.data;
            })
    }

    let create = (data, branchId) => {
        return $http
            .post(AppConstants.api + `/service-ticket-parts/create`, { data, branchId })
            .then((res) => {
                return res.data;
            })
    }

    let update = (id, data) => {
        return $http
            .post(AppConstants.api + `/service-ticket-parts/${id}/update`, data)
            .then((res) => {
                return res.data;
            })
    }

    let get = (id) => {
        return $http
            .get(AppConstants.api + `/service-ticket-parts/${id}/details`)
            .then((res) => {
                return res.data;
            })
    }

    let remove = (id, label, serialNumber, branchId) => {
        return $http
            .delete(AppConstants.api + `/service-ticket-parts/${id}/delete`, {
                params: {
                    id, label, serialNumber, branchId
                }
            })
            .then((res) => {
                return res.data;
            })
    }


    return {
        all,
        create,
        update,
        get,
        remove
    }
};

ServiceTicketPartsService.$inject = ['$http'];

export default ServiceTicketPartsService;


// WEBPACK FOOTER //
// ./client/app/services/service-ticket-parts.service.js